
import "./Leftsignupform.css";
import Input from "../Input/input";
import Lists from "../Lists/lists";

function Leftsignupform () {
    return (
        <div>
            <div className="main-text">
                <h1>
                    Stay updated!
                </h1>
                <p>
                    Join 60,000+ product managers receiving monthly updates on:
                </p>
                <Lists></Lists>
                <Input></Input>
            </div>
        </div>
    );
}

export default Leftsignupform;